import type { JSX } from "react";
import { ProcessType, Variation } from "@/types";

type Process = { process: ProcessType; variation?: Variation | null };

export function renderByProcess<
	TLoan extends Process,
	TCredit extends Process,
	TMoney extends Process = TLoan,
>(
	context: TLoan | TCredit | TMoney,
	components: {
		loan: (context: TLoan) => JSX.Element;
		credit?: (context: TCredit) => JSX.Element;
		salesFinance?: (context: TLoan) => JSX.Element;
		myMoney?: (context: TMoney) => JSX.Element;
	}
): JSX.Element {
	switch (context.process) {
		case ProcessType.CardSE:
			return components.credit
				? components.credit(context as TCredit)
				: components.loan(context as TLoan);
		case ProcessType.LoanSE:
		case ProcessType.LoanFI:
		case ProcessType.LoanNO:
			return context.variation === Variation.CashLoan && components.myMoney
				? components.myMoney(context as TMoney)
				: components.loan(context as TLoan);
		case ProcessType.SalesFinanceSE:
			return components.salesFinance
				? components.salesFinance(context as TLoan)
				: components.loan(context as TLoan);
		default:
			return components.loan(context as TLoan);
	}
}
